'use client'

import ServiceCard from './ServiceCard'

import {
  CloudIcon,
  CogIcon,
  GlobeAltIcon,
  LightBulbIcon,
} from '@heroicons/react/24/solid'

import styles from './ServiceGrid.module.css'

export default function ServiceGrid() {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>
        Lean. Strategic. Built to solve real operational problems.
      </h2>

      <div className={styles.grid}>
        <ServiceCard
          title="SaaS Development"
          description="Launch lean, scalable SaaS products that drive recurring revenue — without bloated infrastructure."
          icon={<CloudIcon className={styles.icon} />}
          slug="saas-development"
        />

        <ServiceCard
          title="Custom Software"
          description="Eliminate bottlenecks and streamline operations with tools built around your team’s real workflow."
          icon={<CogIcon className={styles.icon} />}
          slug="custom-software"
        />

        <ServiceCard
          title="Website Systems"
          description="Ship clean, conversion-focused websites that are easy to maintain and built to scale."
          icon={<GlobeAltIcon className={styles.icon} />}
          slug="website-building"
        />

        <ServiceCard
          title="Consultancy"
          description="Validate faster, build smarter, and avoid costly overengineering with strategic product guidance."
          icon={<LightBulbIcon className={styles.icon} />}
          slug="consultancy"
        />
      </div>
    </section>
  )
}
